import React from "react";
import { Link } from "react-router-dom";
import '../CSS/notfound.css'

function NotFound() {
  return (
    <section className="not-found-section">
      <div className="container text-center">

        <div className="not-found-code">
          404
        </div>

        <h1>
          Page Not Found
        </h1>

        <p>
          Sorry, the page you are looking for doesn't exist
          or may have been moved.
        </p>

        <Link to="/" className="not-found-button">
          Back to Home
        </Link>

      </div>
    </section>
  );
}

export default NotFound;